/**
 * Calls the admin service to trigger a branded password-reset email.
 *
 * Never throws — the ACUL UX should show the same success state regardless
 * of whether the account exists (enumeration-safe). The admin endpoint also
 * always responds 200, but we defend against network errors locally.
 */

interface RequestPasswordResetParams {
  email: string;
  clientId?: string;
}

export function getAdminApiBaseUrl(): string | undefined {
  const url = import.meta.env.VITE_ADMIN_API_BASE_URL as string | undefined;
  return url ? url.replace(/\/+$/, "") : undefined;
}

export async function requestPasswordReset({
  email,
  clientId,
}: RequestPasswordResetParams): Promise<void> {
  const base = getAdminApiBaseUrl();
  if (!base) {
    console.warn(
      "[requestPasswordReset] VITE_ADMIN_API_BASE_URL is not set; skipping"
    );
    return;
  }

  try {
    await fetch(`${base}/api/public/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, clientId }),
      mode: "cors",
      credentials: "omit",
    });
  } catch (error) {
    console.error("[requestPasswordReset] network error", error);
  }
}
